import React, { useState, useEffect } from 'react';
import { Mail, Menu, Phone } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/Iyblogo2photoroom.png';
import { fetchPhones } from "../store/feature/phoneSlice";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const { phones } = useSelector((state: RootState) => state.phone);

  const firstPhone = phones.length > 0 ? phones[0] : null;

  useEffect(() => {
    dispatch(fetchPhones());
  }, [dispatch]);

  const isActive = (path: string) => {
    return location.pathname === path 
      ? "text-blue-300 border-b-2 border-blue-300 pb-1 transition-all duration-300" 
      : "text-white hover:text-blue-200 transition-all duration-300";
  };

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    if (isHomePage) {
      const handleScroll = () => {
        setIsScrolled(window.scrollY > 50);
      };
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isHomePage]);

  return (
    <div>
      <div
        className={`w-full fixed top-0 z-50 ${isHomePage && isScrolled ? 'bg-gray-900' : isHomePage ? 'bg-transparent' : 'bg-gray-900'} transition-colors duration-300`}
      >
        <div className="container mx-auto px-4 py-3 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <img src={logo} alt="Logo" className="h-12" style={{ minHeight: '60px' }} />
          </Link>

          {/* Telefon ve E-posta (1200px ve üzeri için görünür) */}
          <div className="hidden xl:flex items-center gap-6 ml-6">
            <div className="flex items-center gap-2 hover:text-blue-200 transition-colors duration-300">
              <Phone size={18} />
              <a href={`tel:${firstPhone ? firstPhone.value : ''}`} className="text-white hover:text-blue-200 whitespace-nowrap">
                {firstPhone ? firstPhone.value : 'Telefon yok'}
              </a>
            </div>
            <div className="flex items-center gap-2 hover:text-blue-200 transition-colors duration-300">
              <Mail size={18} />
              <a href="mailto:istanbulyerbilimleri@gmail.com" className="text-white hover:text-blue-200 whitespace-nowrap">
                istanbulyerbilimleri@gmail.com
              </a>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-white hover:text-blue-200 transition-colors duration-300"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Menu />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 text-white">
            <ul className="flex gap-6">
              <li>
                <Link to="/" className={isActive('/')} style={{ fontWeight: 'bold' }}>
                  ANASAYFA
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className={isActive('/hakkimizda')} style={{ fontWeight: 'bold' }}>
                  HAKKIMIZDA
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz" className={isActive('/hizmetlerimiz')} style={{ fontWeight: 'bold' }}>
                  HİZMETLERİMİZ
                </Link>
              </li>
              <li>
                <Link to="/referanslarimiz" className={isActive('/referanslarimiz')} style={{ fontWeight: 'bold' }}>
                  REFERANSLARIMIZ
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className={isActive('/iletisim')} style={{ fontWeight: 'bold' }}>
                  İLETİŞİM
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-gray-900">
            <nav className="container mx-auto px-4">
              <ul className="flex flex-col py-4 gap-4 text-white">
                <li className="border-b border-gray-700 pb-2">
                  <Link
                    to="/"
                    onClick={() => setIsMenuOpen(false)}
                    className={`block ${isActive('/')}`}
                  >
                    ANASAYFA
                  </Link>
                </li>
                <li className="border-b border-gray-700 pb-2">
                  <Link
                    to="/hakkimizda"
                    onClick={() => setIsMenuOpen(false)}
                    className={`block ${isActive('/hakkimizda')}`}
                  >
                    HAKKIMIZDA
                  </Link>
                </li>
                <li className="border-b border-gray-700 pb-2">
                  <Link
                    to="/hizmetlerimiz"
                    onClick={() => setIsMenuOpen(false)}
                    className={`block ${isActive('/hizmetlerimiz')}`}
                  >
                    HİZMETLERİMİZ
                  </Link>
                </li>
                <li className="border-b border-gray-700 pb-2">
                  <Link
                    to="/referanslarimiz"
                    onClick={() => setIsMenuOpen(false)}
                    className={`block ${isActive('/referanslarimiz')}`}
                  >
                    REFERANSLARIMIZ
                  </Link>
                </li>
                <li className="border-b border-gray-700 pb-2">
                  <Link
                    to="/iletisim"
                    onClick={() => setIsMenuOpen(false)}
                    className={`block ${isActive('/iletisim')}`}
                  >
                    İLETİŞİM
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
